const sessionLabel = session =>
  session?.remoteIdentity?.displayName ||
  session?.data?.dst ||
  session?.data?.src ||
  session?.remoteIdentity?.uri?.user ||
  '';

const sessionNumber = session =>
  session?.data?.dst ||
  session?.data?.src ||
  session?.remoteIdentity?.uri?.user ||
  '';

const sessionStartedAt = session => {
  const startedAt = session?.data?.startTime;

  if (!startedAt) return null;

  if (typeof startedAt?.valueOf === 'function') {
    const timestamp = startedAt.valueOf();
    if (Number.isFinite(timestamp)) {
      return timestamp;
    }
  }

  const parsedTimestamp = Date.parse(startedAt);
  return Number.isNaN(parsedTimestamp) ? null : parsedTimestamp;
};

const sessionStatus = (session, direction, overrides) => {
  const data = session?.data || {};
  const lastAction = overrides.lastAction;

  if (overrides.status) return overrides.status;

  if (lastAction === 'accepted' || lastAction === 'trackAdded') {
    return session?.isOnHold ? 'on_hold' : 'active';
  }

  if (lastAction === 'hold') return 'on_hold';
  if (lastAction === 'unhold') return 'active';
  if (lastAction === 'trying') return 'trying';
  if (lastAction === 'progress') return 'ringing';

  if (data.started) {
    return session?.isOnHold ? 'on_hold' : 'active';
  }

  if (direction === 'inbound') {
    return 'incoming';
  }

  return 'dialing';
};

export const serializeLegacyError = error => {
  if (!error) return null;
  if (typeof error === 'string') return error;
  if (error.message) return error.message;
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
};

export const normalizeLegacySession = (session, overrides = {}) => {
  const data = session?.data || {};
  const line = data.line ?? overrides.line ?? null;
  const direction = data.calldirection || overrides.direction || 'outbound';
  const status = sessionStatus(session, direction, overrides);
  const recordings = Array.isArray(data.recordings) ? data.recordings : [];
  const mediaRecorderState = session?.data?.mediaRecorder?.state || null;

  return {
    id: String(line || session?.id || `${direction}-${sessionNumber(session)}`),
    line,
    status,
    lastAction: overrides.lastAction || null,
    direction,
    number: sessionNumber(session),
    displayName: sessionLabel(session),
    startedAt: sessionStartedAt(session),
    hasStarted: Boolean(data.started),
    isMuted: Boolean(data.ismute),
    isOnHold: Boolean(session?.isOnHold),
    isRecording: mediaRecorderState === 'recording',
    recordingsCount: recordings.length,
    withVideo: Boolean(data.withvideo),
    reasonText: data.reasonText || null,
    reasonCode: data.reasonCode || null,
  };
};
